import React from 'react';
import { Card, CardContent, Typography, Grid, Box, Chip } from '@mui/material';
import { CalendarToday, TrendingUp } from '@mui/icons-material';
import { Lightbox, useLightBox } from 'src/components/lightbox';

const EntryCard = ({ entry, isCategorical, goalData }) => {
  const imageMedia = entry.media;

  const mediaSlides = imageMedia.map((mediaItem) => ({
    type: 'image',

    src: mediaItem.url,
    sources: [
      {
        src: mediaItem.url,
      },
    ],
    title: entry.title,
    description: '',
  }));

  const lightbox = useLightBox(mediaSlides);

  // FIXED
  const handleImageClick = (url) => {
    lightbox.onOpen(url);
  };

  return (
    <>
      <Card variant="outlined">
        <CardContent>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12}>
              <Box display="flex" alignItems="center" gap={1} mb={1}>
                <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                  {entry.title}
                </Typography>

                <Chip
                  label={entry?.entry_type === 'milestone' ? 'Milestone' : 'Generic'}
                  size="small"
                  color={entry?.entry_type === 'milestone' ? 'success' : 'default'}
                  variant="outlined"
                />
              </Box>

              <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                {entry.notes}
              </Typography>

              {imageMedia.length > 0 && (
                <Box sx={{ mb: 2 }}>
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ mb: 1, display: 'block' }}
                  >
                    Attachments ({imageMedia.length} {imageMedia.length === 1 ? 'image' : 'images'})
                  </Typography>

                  <Box display="flex" gap={1} flexWrap="wrap">
                    {imageMedia.map((mediaItem, index) => (
                      <Box
                        key={mediaItem.id || index}
                        sx={{
                          position: 'relative',
                          width: 80,
                          height: 80,
                          borderRadius: 1,
                          overflow: 'hidden',
                          cursor: 'pointer',
                          transition: 'all 0.3s ease',
                          '&:hover': {
                            transform: 'scale(1.05)',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                          },
                        }}
                        onClick={() => handleImageClick(mediaItem.url)}
                      >
                        <img
                          src={mediaItem.url || mediaItem.media}
                          alt={`${entry.title}-${index}`}
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                          }}
                        />

                        <Box
                          sx={{
                            position: 'absolute',
                            inset: 0,
                            backgroundColor: 'rgba(0,0,0,0.25)',
                            opacity: 0,
                            transition: 'opacity 0.2s',
                            '&:hover': { opacity: 1 },
                          }}
                        />
                      </Box>
                    ))}
                  </Box>
                </Box>
              )}

              <Box display="flex" alignItems="center" justifyContent="space-between">
                <Box display="flex" alignItems="center" gap={0.5}>
                  <CalendarToday sx={{ fontSize: 16 }} />
                  <Typography variant="caption">{entry?.date}</Typography>
                </Box>

                {!isCategorical && entry.value && (
                  <Box display="flex" alignItems="center" gap={0.5}>
                    <TrendingUp sx={{ fontSize: 16 }} />
                    <Typography variant="caption" sx={{ fontWeight: 600 }}>
                      {entry.value} {goalData?.unit?.name}
                    </Typography>
                  </Box>
                )}
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {mediaSlides.length > 0 && (
        <Lightbox
          index={lightbox.selected}
          slides={mediaSlides}
          open={lightbox.open}
          close={lightbox.onClose}
          disableSlideshow
        />
      )}
    </>
  );
};

export default EntryCard;
